import { MessageBarType } from '@fluentui/react';

export type onDataResult = (response: IDataResult) => void;

export interface IResult {
    errorMessages: any;
    summaryText?: string;
    summaryType?: MessageBarType;
}

export interface IDataResult extends IResult {
    data?: any;
    status: ResponseStatus;
}
export enum ResponseStatus {
    fail = 0, success = 1, warning = 2
}

export interface Result {
    status: ResponseStatus;
    description: string;
    returnedValue: any;
    invalidData: { [key: string]: string; };
}

export interface IntResult extends Result { }
export interface StringResult extends Result { }
export interface BoolResult extends Result { }